<template>
  <section>
    <h1 class="section-head">เพิ่มรายการสั่งซื้อ {{ supplier.name }}</h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" :to="backPage"><i class="fas fa-arrow-left"></i>Back</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <button class="button is-success" :class="loadingClass" @click="submit" v-can="'receive_po_item'"><i class="fas fa-box-open"></i>รับสินค้า</button>
          </div>
        </div>
      </div>
    </nav>

    <div class="columns">
      <div class="column">
        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">ซัพพลายเออร์</label>
              <b-field :type="alert.supplier.type" :message="alert.supplier.msg">
                <b-select placeholder="โปรดเลือกซัพพลายเออร์" v-model="supId" @input="supChanged" :disabled="this.$route.params.supId || this.$route.params.id ? true : false">
                  <option v-for="supplier in supplierList" :value="supplier.id" :key="supplier.id">
                    {{ supplier.name }}
                  </option>
                </b-select>
              </b-field>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="field-body">
            <div class="field">
              <label class="label">Attention</label>
              <input v-model="order.attention" placeholder="Attention" class="input is-static" readonly />
            </div>
            <div class="field"></div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <h1 class="section-sub-head">สินค้าตามรายการสั่งซื้อ</h1>
    </div>

    <div>
      <b-table :data="order.items" :hoverable="true" :loading="isLoading" v-if="(order.items && order.items.length > 0) || this.isLoading">
        <template slot-scope="props">
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์" width="250"> {{ props.row.name }} ({{ props.row.cus_name }}) </b-table-column>

          <b-table-column field="price_sell" label="จำนวนสั่ง" width="120"> {{ props.row.quantity }} {{ props.row.unit_text }} </b-table-column>

          <b-table-column field="left" label="จำนวนค้างรับ" width="120">
            {{ props.row.received ? props.row.quantity - props.row.received : props.row.quantity }} {{ props.row.unit_text }}
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนรับ" width="120">
            <div class="field has-addons">
              <p class="control">
                <b-input
                  placeholder="จำนวนรับ"
                  @input="checkOverInput(props.row.pro_id, props.row.cus_id)"
                  :disabled="props.row.quantity - props.row.received < 1"
                  v-model="order.items[props.index].receiving"
                ></b-input>
              </p>
              <p class="control">
                <button class="button is-static">
                  {{ props.row.unit_text }}
                </button>
              </p>
            </div>
          </b-table-column>
        </template>
      </b-table>

      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์</div>
    </div>

    <hr />

    <div class="margin-botton-10">
      <h1 class="section-sub-head">สินค้า Promotion <button class="button is-small is-info is-rounded is-centered is-pulled-right" @click="openModal">เพิ่มผลิตภัณฑ์</button></h1>
    </div>

    <div>
      <b-table :data="order.promotionItems" :hoverable="true" :loading="isLoading" v-if="(order.promotionItems && order.promotionItems.length > 0) || this.isLoading">
        <template slot-scope="props">
          <b-table-column field="name" label="ชื่อผลิตภัณฑ์">
            {{ props.row.pro_name }}
          </b-table-column>

          <b-table-column field="price_sell" label="จำนวนรับ" width="220">
            <div class="field has-addons">
              <p class="control">
                <b-input placeholder="จำนวนรับ" v-model="order.promotionItems[props.index].amount"></b-input>
              </p>
              <p class="control">
                <button class="button is-static">
                  {{ props.row.unit_buy_text }}
                </button>
              </p>
            </div>
          </b-table-column>

          <b-table-column field="price_sell" label="หมายเหตุ" width="420">
            <div class="field has-addons">
              <b-input :expanded="true" placeholder="หมายเหตุ" v-model="order.promotionItems[props.index].remark"></b-input>
            </div>
          </b-table-column>
        </template>
      </b-table>

      <div class="notification has-text-centered" v-else>ไม่มีรายการผลิตภัณฑ์ Promotion</div>
    </div>

    <b-modal :active.sync="isModalActive" @close="closeModal">
      <div class="modal-card product-add-modal" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">เพิ่มรายการผลิตภัณฑ์ได้รับจาก Promotion</p>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column is-8">
              <b-field label="ชื่อผลิตภัณฑ์">
                <b-autocomplete
                  v-model="productSelectingName"
                  placeholder="e.g. Product Name"
                  :keep-first="true"
                  :open-on-focus="true"
                  :data="filteredProductObj"
                  field="name"
                  @select="selectedProduct"
                  :disabled="products.length < 1"
                >
                </b-autocomplete>
              </b-field>
            </div>
            <div class="column is-4">
              <div class="field">
                <label class="label">จำนวน</label>
                <div class="field-body">
                  <div class="field is-expanded">
                    <div class="field has-addons">
                      <p class="control is-expanded">
                        <input class="input" type="number" placeholder="จำนวน" v-model="modalValue.amount" />
                      </p>
                      <p class="control">
                        <a class="button is-static">
                          {{ productSelecting != null ? productSelecting.unit_buy_text : '-' }}
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <b-field label="หมายเหตุ">
                <b-input v-model="modalValue.remark" type="textarea" placeholder="หมายเหตุ" rows="5"> </b-input>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot" style="justify-content: space-between;">
          <button class="button is-pulled-right" type="button is-warning" @click="closeModal">ปิด</button>
          <button v-if="modalValue.isModalEdit" class="button is-center is-danger" type="button" @click="deleteEditingItem"><i class="fas fa-trash"></i>ลบรายการนี้</button>
          <button class="button is-primary is-pulled-right" @click="addProduct">เพิ่ม</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import Request from '@/libraries/request';
import ProductModel from '@/model/product_model';
import SupplierModel from '@/model/supplier_model';
import PurchaseOrderModel from '@/model/purchaseorder_model';
import Const from '@/const/const';

export default {
  data() {
    return {
      order: {},
      items: [],
      receive: [],
      supId: this.$route.params.supId ? this.$route.params.supId : null,
      isLoading: true,
      backPage: this.$route.params.supId ? '/supplier/view/' + this.$route.params.supId : this.$route.params.id ? '/purchaseorder/view/' + this.$route.params.id : '/purchaseorder',
      supplier: {},
      supplierList: {},
      products: [],
      alert: {
        supplier: {
          type: '',
          msg: '',
        },
      },
      loadingClass: '',

      productSelected: [],
      productSelecting: [],
      productSelectingName: '',
      isModalActive: false,
      modalValue: {},
      lastSelected: {},
    };
  },
  mounted() {
    this.isLoading = true;
    this.init();
  },
  computed: {
    filteredProductObj() {
      return this.products.filter(option => {
        if (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.productSelectingName.toLowerCase()) >= 0
        ) {
          return option;
        } else {
          return false;
        }
      });
    },
  },
  methods: {
    async init() {
      try {
        this.supplierList = await SupplierModel.get_all_supplier();
        if (this.$route.params.id) {
          this.order = await PurchaseOrderModel.get_order(this.$route.params.id);
          this.supId = this.order.sup_id;
        }
        this.order.promotionItems = [];
        if (this.supId) {
          this.supplier = await SupplierModel.get_supplier(this.supId);
          this.products = await ProductModel.get_supplier_product(this.supId);
        }
      } catch (e) {
        this.$buefy.snackbar.open(e.message);
        this.$router.push('/supplier/view/' + this.supId);
      }
      this.isLoading = false;
    },
    async supChanged() {
      if (!this.$route.params.id) {
        this.isLoading = true;
        this.supplier = await SupplierModel.get_supplier(this.supId);
        this.products = await ProductModel.get_supplier_product(this.supId);
        this.discount = {};
        this.amount = {};
        this.total = {};
      }
      this.isLoading = false;
    },
    checkOverInput(id, cus_id) {
      //console.log("Check!");
      for (const [key, item] of Object.entries(this.order.items)) {
        if (item['pro_id'] == id && item['cus_id'] == cus_id) {
          if (this.order.items[key].receiving > item.quantity - item.received) {
            this.order.items[key].receiving = '';
          }
        }
      }
    },
    openModal() {
      this.lastSelected = null;
      this.isModalActive = true;
    },
    closeModal() {
      this.isModalActive = false;
      this.modalValue = {};
      this.productSelecting = {};
      this.productSelectingName = '';
      this.modalValue.isModalEdit = false;
    },
    selectedProduct(option) {
      this.productSelecting = option;
      // console.log(this.productSelecting);
      if (this.productSelecting !== null) {
        this.modalValue.pro_id = this.productSelecting.id;
        this.modalValue.pro_name = this.productSelecting.name;
        this.modalValue.unit_buy_text = this.productSelecting.unit_buy_text;
        this.modalValue.price_buy = this.productSelecting.price_buy;
      }
    },
    addProduct() {
      let item = this.modalValue;
      // console.log(this.productSelecting);
      // console.log("item: ",item);
      const isExist = this.order.promotionItems.filter(function(currentListedItem) {
        // console.log("currentListedItem: ",currentListedItem);
        if (currentListedItem.pro_id == item.pro_id && currentListedItem.cus_id == item.cus_id) {
          return currentListedItem;
        }
      });
      if (isExist.length > 0) {
        this.order.promotionItems.splice(this.order.promotionItems.indexOf(isExist[0]), 1);
      }
      this.order.promotionItems.push(item);
      this.closeModal();
    },
    submit() {
      this.loadingClass = 'is-loading';
      let data = {};
      data.order_id = this.order.id;
      data.items = [];
      data.promotionItems = [];

      for (const [keyItem, item] of Object.entries(this.order.items)) {
        if (item.receiving > item.quantity - item.received) {
          item.receiving = item.quantity - item.received;
        }
        data.items[keyItem] = item;
      }
      for (const [keyItem, promotionItem] of Object.entries(this.order.promotionItems)) {
        data.promotionItems[keyItem] = promotionItem;
      }

      Request.post('purchaseorder/order_receive', data, res => {
        this.loadingClass = '';
        if (res.data.status) {
          this.$buefy.snackbar.open('รับผลิตภัณฑ์สำเร็จ!');
          this.$router.push({ path: '/purchaseorder/view/' + res.data.data.id });
        }
      });
    },
  },
};
</script>

<style scoped>
.is-static {
  border-bottom: dotted 1px #c7c7c7;
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrder/receive.vue